<template lang="pug">
label.toggle-switch-wrapper.primary-toggle(:class="textPositionClass")
  input(
    type="checkbox"
    :checked="modelCompatValue"
    :disabled="disabled"
    @change="toggle($event)"
  )
  .toggle-switch
  .inline-control-label(v-if="label")
    | {{ label }}
  .inline-control-label(v-else)
    slot
</template>

<script>
import VModelCompat from '~/mixins/v_model_compat';

export default {
  name: 'AppSwitch',
  mixins: [VModelCompat],
  props: {
    modelValue: {
      type: Boolean,
      default: undefined,
    },
    label: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    textPosition: {
      type: String,
      default: 'right',
    },
  },
  emits: ['change', 'update:modelValue'],
  computed: {
    textPositionClass() {
      return `toggle-switch-text-${this.textPosition}`;
    },
  },
  methods: {
    toggle(e) {
      this.$emit('change', e.target.checked);
      this.$emit('update:modelValue', e.target.checked);
    },
  },
};
</script>
